<div class="bloco" [formGroup]="form">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>CST ICMS</mat-label>
        <mat-select formControlName="codigoCst" (selectionChange)="onCstSelecionado()">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of listaCstIcmsDaOperacao; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCstIcms.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    @if (isComCst) {
      @if (cstIcmsTexto) {
      <div class="col-12">
        <app-alert-card [type]="cstIcmsTexto.alertaTipo" [title]="cstIcmsTexto.alertaTitulo">
          {{ cstIcmsTexto.alertaTexto }}
        </app-alert-card>
      </div>
      }
    } @else {
      <div class="col-12">
        <app-empty-state icon="percent" title="Selecione o CST"
          subtitle="Os campos e os valores apurados aparecem conforme o código informado."></app-empty-state>
      </div>
    }

    @if (ativo('modBC')) {
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Modalidade da BC do ICMS</mat-label>
          <mat-select formControlName="codigoModalidadeBaseCalculo">
            @for (m of listaModalidadeBc; track m.valor) {
              <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
            }
          </mat-select>
          @if (form.get('codigoModalidadeBaseCalculo')?.hasError('required') && form.get('codigoModalidadeBaseCalculo')?.touched) {
            <mat-error>Modalidade da BC é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pRedBC')) {
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Redução da base de cálculo (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoBaseCalculo" class="campo-numero">
          @if (form.get('percentualReducaoBaseCalculo')?.hasError('required') && form.get('percentualReducaoBaseCalculo')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pICMS')) {
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota ICMS (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquota" class="campo-numero">
          @if (form.get('percentualAliquota')?.hasError('required') && form.get('percentualAliquota')?.touched) {
            <mat-error>Alíquota do ICMS é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pFCP')) {
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>FCP (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcp" class="campo-numero">
          @if (form.get('percentualFcp')?.hasError('required') && form.get('percentualFcp')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>swap_horiz</mat-icon>
            <span>Substituição tributária (ICMS-ST)</span>
          </div>
          <div class="row g-3">
            @if (ativo('modBCST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Modalidade da BC da ST</mat-label>
                <mat-select formControlName="codigoModalidadeBaseCalculoSt">
                  @for (m of listaModalidadeBcSt; track m.valor) {
                    <mat-option [value]="m.valor">{{ m.descricao }}</mat-option>
                  }
                </mat-select>
                @if (form.get('codigoModalidadeBaseCalculoSt')?.hasError('required') && form.get('codigoModalidadeBaseCalculoSt')?.touched) {
                  <mat-error>Modalidade da BC da ST é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pMVAST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>MVA ajustado (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualMvaSt" class="campo-numero">
                @if (form.get('percentualMvaSt')?.hasError('required') && form.get('percentualMvaSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pRedBCST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Redução da base de cálculo ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoBaseCalculoSt" class="campo-numero">
                @if (form.get('percentualReducaoBaseCalculoSt')?.hasError('required') && form.get('percentualReducaoBaseCalculoSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pICMSST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ICMS-ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaSt" class="campo-numero">
                @if (form.get('percentualAliquotaSt')?.hasError('required') && form.get('percentualAliquotaSt')?.touched) {
                  <mat-error>Alíquota do ICMS-ST é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Base do FCP ST</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="valorMask" formControlName="valorBaseFcpSt" class="campo-numero">
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>FCP retido por ST (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcpSt" class="campo-numero">
                @if (form.get('percentualFcpSt')?.hasError('required') && form.get('percentualFcpSt')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (ativo('pDif')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Diferimento (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualDiferimento" class="campo-numero">
          @if (form.get('percentualDiferimento')?.hasError('required') && form.get('percentualDiferimento')?.touched) {
            <mat-error>Percentual de diferimento é obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('pRedAdRem')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Redução da alíquota ad rem (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualReducaoAdrem" class="campo-numero">
          @if (form.get('percentualReducaoAdrem')?.hasError('required') && form.get('percentualReducaoAdrem')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (ativo('motDesICMS')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Motivo da desoneração do ICMS</mat-label>
          <mat-select formControlName="codigoMotivoDesoneracao">
            @for (m of listaMotivoDesoneracao; track m.codigo) {
              <mat-option [value]="m.codigo">{{ m.codigo }} - {{ m.descricao }}</mat-option>
            }
          </mat-select>
          @if (form.get('codigoMotivoDesoneracao')?.hasError('required') && form.get('codigoMotivoDesoneracao')?.touched) {
            <mat-error>Preenchimento obrigatório.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (algumAtivo(['pST', 'pFCPSTRet'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>receipt</mat-icon>
            <span>ST cobrada anteriormente</span>
          </div>
          <div class="row g-3">
            @if (ativo('pST')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota suportada pelo consumidor (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualSuporteStRetido" class="campo-numero">
                @if (form.get('percentualSuporteStRetido')?.hasError('required') && form.get('percentualSuporteStRetido')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
            @if (ativo('pFCPSTRet')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>FCP ST retido (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualFcpStRetido" class="campo-numero">
                @if (form.get('percentualFcpStRetido')?.hasError('required') && form.get('percentualFcpStRetido')?.touched) {
                  <mat-error>Preenchimento obrigatório.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (ativo('pICMSEfet')) {
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
          <mat-label>Alíquota efetiva ICMS (%)</mat-label>
          <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaEfetiva" class="campo-numero">
          @if (form.get('percentualAliquotaEfetiva')?.hasError('required') && form.get('percentualAliquotaEfetiva')?.touched) {
            <mat-error>Alíquota do ICMS efetivo é obrigatória.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (algumAtivo(['qBCMono', 'adRemICMS'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>local_gas_station</mat-icon>
            <span>ICMS monofásico próprio</span>
          </div>
          <div class="row g-3">
            @if (ativo('qBCMono')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Quantidade tributada (qBCMono)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="quantidadeBaseMonofasica" class="campo-numero">
              </mat-form-field>
            </div>
            }
            @if (ativo('adRemICMS')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ad rem (adRemICMS)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="valorAliquotaAdremMonofasica" class="campo-numero">
                @if (form.get('valorAliquotaAdremMonofasica')?.hasError('required') && form.get('valorAliquotaAdremMonofasica')?.touched) {
                  <mat-error>Alíquota ad rem é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (algumAtivo(['qBCMonoReten', 'adRemICMSReten'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>local_gas_station</mat-icon>
            <span>ICMS monofásico sujeito a retenção</span>
          </div>
          <div class="row g-3">
            @if (ativo('qBCMonoReten')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Quantidade tributada (qBCMonoReten)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="quantidadeBaseMonofasicaRetencao" class="campo-numero">
              </mat-form-field>
            </div>
            }
            @if (ativo('adRemICMSReten')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ad rem (adRemICMSReten)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="valorAliquotaAdremMonofasicaRetencao" class="campo-numero">
                @if (form.get('valorAliquotaAdremMonofasicaRetencao')?.hasError('required') && form.get('valorAliquotaAdremMonofasicaRetencao')?.touched) {
                  <mat-error>Alíquota ad rem da retenção é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (algumAtivo(['qBCMonoRet', 'adRemICMSRet'])) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>local_gas_station</mat-icon>
            <span>ICMS monofásico retido anteriormente</span>
          </div>
          <div class="row g-3">
            @if (ativo('qBCMonoRet')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Quantidade tributada (qBCMonoRet)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="quantidadeBaseMonofasicaRetido" class="campo-numero">
              </mat-form-field>
            </div>
            }
            @if (ativo('adRemICMSRet')) {
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota ad rem (adRemICMSRet)</mat-label>
                <input matInput type="text" inputmode="decimal" [currencyMask]="quantidadeMask" formControlName="valorAliquotaAdremMonofasicaRetido" class="campo-numero">
                @if (form.get('valorAliquotaAdremMonofasicaRetido')?.hasError('required') && form.get('valorAliquotaAdremMonofasicaRetido')?.touched) {
                  <mat-error>Alíquota ad rem retida é obrigatória.</mat-error>
                }
              </mat-form-field>
            </div>
            }
          </div>
        </div>
      </div>
    }

    @if (isComCst) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>calculate</mat-icon>
            <span>Valores apurados</span>
          </div>
          @if (isRecalculoPendente || !isComValoresApurados) {
            <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
          } @else {
            <div class="row g-3">
              @if (isMonofasico) {
                @if (algumAtivo(['qBCMono', 'adRemICMS'])) {
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>ICMS monofásico próprio</mat-label>
                      <input matInput type="text" [value]="form.get('valorIcmsMonofasico')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                }
                @if (algumAtivo(['qBCMonoReten', 'adRemICMSReten'])) {
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>ICMS monofásico retenção</mat-label>
                      <input matInput type="text" [value]="form.get('valorIcmsMonofasicoRetencao')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                }
                @if (algumAtivo(['qBCMonoRet', 'adRemICMSRet'])) {
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>ICMS monofásico retido</mat-label>
                      <input matInput type="text" [value]="form.get('valorIcmsMonofasicoRetido')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                }
              } @else if (!algumAtivo(['pST', 'pFCPSTRet'])) {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Base</mat-label>
                    <input matInput type="text" [value]="form.get('valorBaseCalculo')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota (%)</mat-label>
                    <input matInput type="text" [value]="form.get('percentualAliquota')?.value || 0 | abnt: 'quantidade': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor do ICMS</mat-label>
                    <input matInput type="text" [value]="form.get('valorIcms')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor do FCP</mat-label>
                    <input matInput type="text" [value]="form.get('valorFcp')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                @if (algumAtivo(['modBCST', 'pMVAST', 'pRedBCST', 'pICMSST', 'pFCPST'])) {
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Base ICMS-ST</mat-label>
                      <input matInput type="text" [value]="form.get('valorBaseCalculoSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Valor ICMS-ST</mat-label>
                      <input matInput type="text" [value]="form.get('valorIcmsSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                  <div class="col-6 col-md-3">
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Valor FCP ST</mat-label>
                      <input matInput type="text" [value]="form.get('valorFcpSt')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                    </mat-form-field>
                  </div>
                }
              } @else {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Base ICMS</mat-label>
                    <input matInput type="text" [value]="form.get('valorBaseCalculo')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>ICMS próprio</mat-label>
                    <input matInput type="text" [value]="form.get('valorIcms')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Base ICMS-ST retido</mat-label>
                    <input matInput type="text" [value]="form.get('valorBaseCalculoStRetido')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Valor ICMS-ST retido</mat-label>
                    <input matInput type="text" [value]="form.get('valorIcmsStRetido')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
